<template>
	<div  class="scrollable only-y" style="margin-left:auto;margin-right:auto;max-width:1500px;">
    <div class="customer-top-nav">
			<span class="title" >{{ $t('products.title') }}</span>
			<div class="controls">
        <el-button @click="addItem();" size="small" type="primary">{{$t('products.addProduct')}}</el-button>
        <el-dropdown size="small"   class="ml-10">
			<el-button  size="small">
				<i class="mdi mdi-download"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<!-- <el-dropdown-item @click.native="handleDownload('EXCEL_EXPORT')" > <span class="mdi mdi-download"> {{ $t('products.downloadProductsCSV') }}</span></el-dropdown-item> -->
				<el-dropdown-item @click.native="handleDownload('EXCEL_QUICKBOOKS')" > <span class="mdi mdi-download"> {{ $t('products.downloadProductsCSVQuickbooks') }} </span></el-dropdown-item>
			</el-dropdown-menu>
      </el-dropdown>
			</div>
		</div>
    <!-- <el-row :gutter="20" v-if="getNbProducts>0 || statsLoading">
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-loading="statsLoading">
        <InfoStatsCard  v-bind:text="'Total'" :total="getNbProductsToString" v-bind:sign="''" v-bind:icon="'mdi-camera-timer'" v-bind:trend="''" v-bind:status="'success'"></InfoStatsCard>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-loading="statsLoading">
        <InfoStatsCard v-bind:text="$t('products.active')" v-bind:total="getNbActiveProductToString" v-bind:sign="''" v-bind:icon="'mdi-check'" v-bind:trend="'mdi-trending-up'" v-bind:status="'success'" ></InfoStatsCard>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-loading="statsLoading">
        <InfoStatsCard  v-bind:text="$t('products.inactive')" v-bind:total="getNbInactiveProductToString" v-bind:sign="''" v-bind:icon="'mdi-alert-circle-outline'" v-bind:trend="'mdi-trending-up'" v-bind:status="'warning'" ></InfoStatsCard>
      </el-col>
    </el-row> -->
    <el-row type="flex" justify="end" v-if="getNbProducts>0 || loading">
      <el-col>
        <!-- <el-popover
          placement="right"
          width="400"
          trigger="click"
					ref="filterPopover"
					:visible-arrow="true">
          <el-form label-position="top">
              <h3>Filtres</h3>
              <el-form-item label="Montrer les produits :">
                <el-checkbox-group v-model="checkedItemTaxables" size="mini" @change="checkedItemTaxablesChanged">
                  <el-checkbox-button v-for="item in filters.taxable" :label="item.id" :key="item.id">{{item.label}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="Montrer les produits de type :">
                <el-checkbox-group v-model="checkedItemTypes" size="mini" @change="checkedItemTypesChanged">
                  <el-checkbox-button v-for="item in filters.type" :label="item.id" :key="item.id">{{item.label}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="Montrer les produits :">
                <el-checkbox-group v-model="checkedItemActives" size="mini" @change="checkedItemActivesChanged">
                  <el-checkbox-button v-for="item in filters.active" :label="item.id" :key="item.id">{{item.label}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
        </el-popover> -->

        <el-input
          clearable
          v-model="search"
          placeholder="Rechercher">
			<!-- <el-button slot="prepend" v-popover:filterPopover ><i class="mdi mdi-filter-variant" style="font-size:15px;"></i></el-button>-->
        </el-input> 
      </el-col>
    </el-row>
    <el-row v-if="getNbProducts==0">
      <noItemsCallToAction @createNewItem="addItem"></noItemsCallToAction>
    </el-row>

    <div v-if="products.length > 0 || loading == true" class="table-box card-base card-shadow--medium scrollable only-x">
      <div class="flex center m-10">
        <Pagination
          class="box right mt-5 mb-0 fs-14 secondary-text"
          :current-page="page"
          :total-number-of-page="pages"
          @click-previous="fetchPreviousPage"
          @click-next="fetchNextPage" />
      </div>
      <el-table
        :data="products"
        :default-sort = "{prop: 'code', order: 'ascending'}"
        class="itemsTable"
        style="width: 100%"
        :height="getHeight"
        @sort-change="handleSortChange"
				v-loading="loading">
        <el-table-column
          align="left"
          width="100"
          fixed>

          <template slot-scope="scope">
            <el-button
              size="mini"
							circle
              :disabled="!canWriteProductInfos"
              @click="handleEdit(scope.$index, scope.row)"><i class="mdi mdi-lead-pencil" style="font-size:15px;"></i></el-button>
            <el-button :disabled="false"
              size="mini"
              type="danger"
							circle
              @click="handleDelete(scope.$index, scope.row)"><i class="mdi mdi-delete" style="font-size:15px;"></i></el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('products.type')"
          
          width="75"
          fixed
          align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="getTypeString(scope.row)" placement="top">
              <i class="mdi mdi-barcode-scan" v-if="scope.row.type==1" style="font-size:18px;"></i>
              <i class="mdi mdi-cards-variant" v-else="scope.row.type==1" style="font-size:18px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
				<el-table-column
          prop="sku"
          :label="$t('products.sku')"
          
          fixed
          width="120"
          align="left">
          <template slot-scope="scope">
            <el-button  v-if="canReadProductInfos" type="text" @click="handleEdit(scope.$index, scope.row)">{{scope.row.sku}}</el-button>
            <span v-else>{{scope.row.sku}}</span>
          </template>
        </el-table-column>
       
        <el-table-column
          prop="name"
          :label="$t('products.product')"
          show-overflow-tooltip
          fixed
          width="300"
          align="left"
          >
					<template slot-scope="scope">
						<span style="word-break:break-word;">{{scope.row.name}}</span>
					</template>
        </el-table-column>
        <el-table-column v-if="isSystemHasMultiplePortausCompanies" v-for="portausCompany in portausCompanies" :key="portausCompany.id"
          show-overflow-tooltip
          :label="portausCompany.name"
          width="150"
          align="center"
          >
          <template slot-scope="scope">
            <span>
              <i class="accent-text el-icon-success" v-if="getActiveIndicatorByPortausCompany(portausCompany.id, scope.row.portausCompanySettings)"></i>
              <i class="el-icon-error" v-else></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isSystemHasMultiplePortausCompanies" v-for="portausCompany in portausCompanies" :key="portausCompany.id"
          show-overflow-tooltip
          :label="$t('products.active')"
          width="150"
          align="center"
          >
          <template slot-scope="scope">
            <span>
              <i class="accent-text el-icon-success" v-if="getActiveIndicatorByPortausCompany(portausCompany.id, scope.row.portausCompanySettings)"></i>
              <i class="el-icon-error" v-else></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="externalId"
          :label="$t('products.externalId')"
          width="120"
          align="left">
        </el-table-column>
        <el-table-column
          :label="$t('products.format')"
          width="180"
          >
					<template slot-scope="scope">
						<UnitFormatVolumeLabel
              v-if="scope.row.type==1"
              :unit="scope.row.unit"
              :uvc="scope.row.uvc"
              :format="scope.row.format"
              :volume="scope.row.volume"
            />
            <span v-else> -- </span>
					</template>
        </el-table-column>
        <!-- <el-table-column
          align="left"
          prop="scope.row.selling_unit_price"
          width="130"
          v-if="!isSystemHasMultiplePortausCompanies"
          :label="$t('products.referentialPrice')">
          <template slot-scope="scope">
            <span>{{getPrice(scope.row.portausCompanySettings[0])}}$</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          align="left"
          width="130"
          v-if="!isSystemHasMultiplePortausCompanies"
          :label="$t('products.taxes')">
          <template slot-scope="scope">
            <span v-if="scope.row.portausCompanySettings[0].taxable == true">
              <span v-if="scope.row.portausCompanySettings[0].taxes!= null && scope.row.portausCompanySettings[0].taxes.length > 0">
                <span v-for="t in scope.row.portausCompanySettings[0].taxes "><el-tag size="mini" class="mr-2">{{t.name}}</el-tag></span>
              </span>
              <span v-else>{{ $t('products.noTaxes') }}</span>
            </span>
            <span v-else>
              {{ $t('products.nonTaxable') }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column
          align="left"
          width="200"
          :label="$t('products.supplier')" >
					<template slot-scope="scope">
            <span>{{getProviderName(scope.row.provider)}}</span>
					</template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="products.length==0 && getNbProducts!=0" style="text-align:center;margin:50px;">
        <span>{{ $t('products.noProducts') }}</span>
    </div>
    <WatingDialog :visible="waitingDialogVisible"></WatingDialog>
    <itemDialog :dialogVisible.sync="itemDialogVisible"  :itemIdToEdit="itemIdToEdit" @close="closeItemDialog"></itemDialog>
  </div>

</template>

<script>
import InfoStatsCard from '@/components/Info-stat-card'
import Pagination from '@/components/pagination'
import noItemsCallToAction from './components/no-items-call-to-action.vue'
import itemDialog from './components/item-dialog.vue'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel.vue'
import CustomerUtil from '@/utils/customer-util'
import { mapActions, mapState, mapGetters } from 'vuex';
import PortausCompanyAPI from '@/services/API/portaus-company'
import ProductAPI from '@/services/API/product'
import WatingDialog from '@/components/waiting-dialog'

export default {
  data() {
    return {
      itemDialogVisible : false,
      itemIdToEdit : null,
      portausCompanies: [],
      filters : {
        // taxable : [{id:1, label:'Taxable'},{id:0,label:'Non taxable'}],
        // type : [{id:1,label:'Bien'},{id:0, label:'Service'}],
        // active : [{id:1,label:'Actif'},{id:0, label:'Inactif'}],
        orderBy: 'name',
        direction: 'ASC'
      },
      waitingDialogVisible: false,
			checkedItemTypes : [],
			checkedItemTaxables : [],
			checkedItemActives : [],
			window: {
				width: 0,
				height: 0
			}
    };
  },components: {
      InfoStatsCard,
      noItemsCallToAction,
      itemDialog,
      UnitFormatVolumeLabel,
      Pagination,
      WatingDialog,
  },
	methods: {
    handleSortChange ({ prop, order }) {
            // this.filters.orderBy = prop;
            // this.filters.direction = order === 'ascending' ? 'ASC' : 'DESC';
            // this.invalidateList();
            // this.fetchProducts(this.filters);
        },
    handleDownload(report) {
      this.waitingDialogVisible = true;
      return ProductAPI.downloadProductsExport(report)
        .then(() => {
          this.waitingDialogVisible = false
        }).catch((err) => {
          this.$message.error(this.i18n$t('common.errors.generic'));
          this.waitingDialogVisible = false
        })
    },
    getActiveIndicatorByPortausCompany(portausCompanyid, productSettings) {
      const portausCompanySettings = _.find(productSettings, s => s.id === portausCompanyid);
      return _.get(portausCompanySettings, 'active') === true;
    },
    getPortausCompanyObject (portausCompanyid) {
      return _.find(this.portausCompanies, pc => pc.id === portausCompanyid);
    },
    fetchPortausCompany () {
     PortausCompanyAPI.getPortausCompany()
      .then((portausCompanies) => {
        this.portausCompanies = portausCompanies;
      })
   },
    getPrice (product) {
      if (product.sellingUnitPrice != null && product.sellingUnitPrice != '') {
        return product.sellingUnitPrice.toFixed(2);
      }
      return product.sellingUnitPrice
    },
		getProviderName(provider){
      if (provider == null) return null;
      return CustomerUtil.customerName(provider.name, provider.usualName);
    },
    close(){
			this.$router.go(-1);
		},
    getActiveString(item){
        return item.active?this.$t("settings.items.activeItem"):this.$t("settings.items.inactiveItem");
    },
    getTypeString(item){
      return item.type==1?"Bien":"Service";
    },
    addItem(){
        this.openItemDialog();
    },
    openItemDialog(){
      this.itemDialogVisible=true;
    },
    closeItemDialog(){
      this.itemDialogVisible=false;
      this.itemIdToEdit=null;
    },
    handleEdit(index,item){
      this.itemIdToEdit = item.id;
      this.openItemDialog();
    },
		deactivateItem(item){
			// this.$store.commit('deactivateItem', index);
			this.deactivateProduct(item.id)
				.then(()=>{
					this.$notify({
						title: "Désactivation du produit",
						message: "Le produit a été désactivé avec succès!",
						type: 'success'
					});
				}).catch(err=>{
					this.$notify({
						title: "Désactivation du produit",
						message: "Oups... une erreur s'est produit lors de la désactivation du produit. Veuillez réessayer plus tard.",
						type: 'error'
					});
				})
		},
    handleDelete(index,item){
			this.deleteProduct(item.id)
				.then(()=>{
					this.$notify({
						title: "Suppression d'un produit",
						message: "Le produit a été supprimé avec succès!",
						type: 'success'
					});
				}).catch(err=>{
					if(err.response.data.message!=="PRODUCT_CANNOT_BE_DELETED_INVENTORY"){
						this.$notify({
							title: "Suppression d'un produit",
							message: "Impossible de supprimer ce produit car il reste des quantités en inventaire!",
							type: 'error'
						});
					}else{
						this.$confirm("Le produit ne peut être supprimé. Toutefois, vous pouvez le désactiver. Voulez-vous procédez à la désactivation du produit ?", 'Warning', {
		          confirmButtonText: 'Oui, je veux le désactiver',
		          cancelButtonText: 'Annuler',
		          type: 'warning',
		          center: true
		        }).then(() => {
							this.deactivateItem(item)
		        })
					}
				})
    },
		checkedItemTypesChanged(){
			this.setCheckedItemTypes(this.checkedItemTypes);
		},
		checkedItemTaxablesChanged(){
			this.setCheckedItemTaxables(this.checkedItemTaxables);
		},
		checkedItemActivesChanged(){
			this.setCheckedItemActives(this.checkedItemActives);
		},
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
		...mapActions('products',['setOrigin', 'setActiveFilter','fetchProducts', 'fetchPreviousPage', 'fetchNextPage', 'productFilters','setSearchTerms','getProductsStats','setCheckedItemTypes','setCheckedItemTaxables','setCheckedItemActives','deleteProduct','updateProduct','deactivateProduct','setExtendedObject', 'invalidateList']),
	},
	computed: {
    isSystemHasMultiplePortausCompanies () {
      return this.portausCompanies.length > 1;
    },
    canReadProductInfos (){
      return this.$can('read', 'ConfigProducts');
    },
    canWriteProductInfos (){
      return this.$can('write', 'ConfigProducts');
    },
		search : {
				set(val){ this.setSearchTerms({ searchTerms :val })},
				get(){return this.searchTerms}
		},
		getHeight(){
			return (this.window.height-250);
		},
		...mapState('products', ['products','loading','page','pages','limit', 'count','searchTerms','statsLoading']),
		...mapGetters('products', ['getNbProducts','getNbProductsToString','getNbActiveProductToString','getNbInactiveProductToString']),
	},
	created(){
    this.fetchPortausCompany();
    this.setOrigin('ERP');
    this.setExtendedObject(['taxes', 'tags', 'contents', 'items', 'attributes', 'cmsProvider']);
		this.getProductsStats();
    this.invalidateList();
    this.fetchProducts(this.filters);
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.el-table__body-wrapper{
  max-height:none;
}

.table-box{
  max-width:1500px;
}

.title {
	font-size : 1.8em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
